package com.example.monetix.utils

interface BiometricAuth {
    fun isAvailable(): Boolean
    fun authenticate(
        title: String = "Sblocco Biometrico",
        subtitle: String = "Autenticati per accedere a Monetix",
        onSuccess: () -> Unit,
        onError: (String) -> Unit
    )
}

var biometricAuth: BiometricAuth? = null
